// 分享初始化参数
let shareInitParam = {
    title: "VIP季卡 买1得10",
    desc: "10大联合会员限量开抢！腾讯视频、QQ音乐、优酷、酷狗音乐、网易云音乐……",
    imgurl: "https://static3w.kuaikanmanhua.com/static-kuaikan-h5-fe/img/wx-share-icon.dd360c4.png", // 分享的小icon
    shareimageurl: "https://stag3w.kuaikanmanhua.com/static-kuaikan-h5-fe/img/share-banner.44b0773.png", // 分享的大图
};
// 分享参数
let shareParam = {
    title: "VIP季卡 买1得10",
    desc: "10大联合会员限量开抢！腾讯视频、QQ音乐、优酷、酷狗音乐、网易云音乐……",
    imgurl: "https://stag3w.kuaikanmanhua.com/static-kuaikan-h5-fe/img/share-banner.44b0773.png",
    shareimageurl: "https://static3w.kuaikanmanhua.com/static-kuaikan-h5-fe/img/wx-share-icon.dd360c4.png",
};


//获取url中参数
const getParam = (() => {
    var assoc = {};
    var decode = function (s) {
        return decodeURIComponent(s.replace(/\+/g, " "));
    };
    var queryString = location.search.substring(1);
    var keyValues = queryString.split('&');
    for (var i in keyValues) {
        var key = keyValues[i].split('=');
        if (key.length > 1) {
            assoc[decode(key[0])] = decode(key[1]);
        }
    }
    return assoc;
})()

let params = {
    activity_name: getParam["act_name"] ? getParam["act_name"] : "",
    activity_name_topic: getParam["act_name_topic"] ? getParam["act_name_topic"] : "",
    pool_name: getParam["pool_name"] ? getParam["pool_name"] : "",
    ipt_third_activity: getParam["ipt_name"] ? getParam["ipt_name"] : "",
    is_jailbroken_phone_url: getParam["non_iap_supported"] ? getParam["non_iap_supported"] : 0,
    topic_id: getParam["topic_id"] ? getParam["topic_id"] : 0,
    comic_id: getParam["comic_id"] ? getParam["comic_id"] : 0,
    origin: getParam["origin"] ? getParam["origin"] : "HomePage",
    cps: getParam["cps"] ? getParam["cps"] : "",
}
export { shareInitParam, shareParam };
export const { activity_name, activity_name_topic, pool_name, ipt_third_activity, is_jailbroken_phone_url, topic_id, comic_id, origin, cps } = params;
export { getParam };



// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/js/params.js